import React from "react";

const Php = () => {
  return <h1>Php page content</h1>;
};

export default Php;